// Mock data para MAESI - Maquinados Equipos y Servicios Industriales

export const companyInfo = {
  name: "MAESI",
  fullName: "Maquinados Equipos y Servicios Industriales",
  tagline: "Soluciones industriales hechas con precisión, calidad y confianza",
  founded: "1998",
  location: {
    address: "Francisco Villa 1617",
    colony: "Col. División del Norte",
    city: "Zapopan",
    state: "Jalisco",
    zipCode: "CP 45187",
    fullAddress: "Francisco Villa 1617, Col. División del Norte, Zapopan, Jalisco, CP 45187"
  },
  contact: {
    email: "contacto@maesisolucionesindustriales.com",
    whatsapp: "+52 33 3822 4611",
    whatsappDisplay: "33 3822 4611",
    phone: "(33) 3342-0145",
    phone2: "33 3822 4611"
  },
  social: {
    facebook: "",
    instagram: "",
    googleBusiness: ""
  }
};

export const mision = "Diseñar y crear soluciones de maquinaria industrial que superen las expectativas de nuestros clientes, ofreciendo productos y servicios de la más alta calidad.";

export const vision = "Ser líderes en innovación, eficiencia y satisfacción dentro de la industria, fomentando relaciones de confianza a largo plazo.";

export const valores = [
  {
    id: 1,
    title: "Honestidad",
    description: "Actuamos con transparencia y ética en cada proyecto",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Calidad",
    description: "Compromiso con la excelencia en cada solución que entregamos",
    icon: "Award"
  },
  {
    id: 3,
    title: "Precisión",
    description: "Atención meticulosa a cada detalle técnico y operativo",
    icon: "Target"
  }
];

export const productos = [
  {
    id: 1,
    name: "Llenadoras Industriales",
    category: "Llenado",
    description: "Máquinas llenadoras de alta precisión para líquidos y productos viscosos. Diseñadas para optimizar tu línea de producción con tecnología de punta.",
    images: [
      "/images/llenadora-1.jpg",
      "/images/llenadora-2.jpg",
      "/images/llenadora-3.jpg"
    ],
    features: ["Alta precisión", "Ajuste automático", "Acero inoxidable", "Fácil limpieza"]
  },
  {
    id: 2,
    name: "Etiquetadoras Automáticas",
    category: "Etiquetado",
    description: "Sistemas de etiquetado automático que garantizan presentación profesional y consistente en cada producto.",
    images: [
      "/images/etiquetadora-1.jpg",
      "/images/etiquetadora-2.jpg",
      "/images/etiquetadora-3.jpg"
    ],
    features: ["Aplicación precisa", "Alta velocidad", "Versatilidad", "Bajo mantenimiento"]
  },
  {
    id: 3,
    name: "Agitadores Industriales",
    category: "Mezcla",
    description: "Agitadores robustos diseñados para mezclas homogéneas en procesos industriales exigentes.",
    images: [
      "/images/agitador-1.jpg",
      "/images/agitador-2.jpg",
      "/images/agitador-3.jpg",
      "/images/agitador-4.jpg"
    ],
    features: ["Potencia variable", "Diseño robusto", "Control de velocidad", "Alta eficiencia"]
  },
  {
    id: 4,
    name: "Transportadores Industriales",
    category: "Transporte",
    description: "Sistemas de transporte que optimizan el flujo de producción con seguridad y eficiencia.",
    images: [
      "/images/transportador-1.jpg",
      "/images/transportador-2.jpg"
    ],
    features: ["Velocidad ajustable", "Modular", "Alta durabilidad", "Fácil instalación"]
  },
  {
    id: 5,
    name: "Tanques de Proceso",
    category: "Almacenamiento",
    description: "Tanques diseñados a medida para almacenamiento y procesamiento de líquidos en entornos industriales.",
    images: [
      "/images/tanque-1.jpg",
      "/images/tanque-2.jpg",
      "/images/tanque-3.jpg"
    ],
    features: ["Diseño personalizado", "Acero inoxidable", "Control de temperatura", "Certificaciones"]
  }
];

export const servicios = [
  {
    id: 1,
    title: "Personalización de Maquinaria",
    description: "Diseñamos y fabricamos soluciones a la medida de tus necesidades específicas. Cada proyecto es único y se adapta perfectamente a tu línea de producción.",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Asesoría Técnica Especializada",
    description: "Nuestro equipo de ingenieros te guía en la selección y optimización de equipos para maximizar la eficiencia de tu producción.",
    icon: "Users"
  },
  {
    id: 3,
    title: "Instalación y Puesta en Marcha",
    description: "Instalamos y configuramos tu maquinaria asegurando un arranque óptimo y capacitación completa para tu personal.",
    icon: "Wrench"
  },
  {
    id: 4,
    title: "Mantenimiento Preventivo",
    description: "Programas de mantenimiento que prolongan la vida útil de tus equipos y previenen paros no programados.",
    icon: "RotateCw"
  },
  {
    id: 5,
    title: "Soporte Técnico",
    description: "Atención rápida y efectiva ante cualquier eventualidad. Estamos disponibles para resolver tus dudas y necesidades.",
    icon: "HeadphonesIcon"
  },
  {
    id: 6,
    title: "Refacciones y Actualizaciones",
    description: "Disponibilidad de refacciones originales y actualizaciones tecnológicas para mantener tu maquinaria al día.",
    icon: "Package"
  }
];

export const diferenciadores = [
  {
    id: 1,
    title: "Calidad Superior",
    description: "Productos fabricados con materiales de primera calidad y procesos certificados"
  },
  {
    id: 2,
    title: "Precio Competitivo",
    description: "Mejor relación calidad-precio del mercado sin comprometer excelencia"
  },
  {
    id: 3,
    title: "Atención Personalizada",
    description: "Cada cliente recibe soluciones diseñadas específicamente para sus necesidades"
  },
  {
    id: 4,
    title: "Experiencia Comprobada",
    description: "Más de 25 años desarrollando soluciones industriales confiables"
  }
];

export const stats = [
  { id: 1, number: "25+", label: "Años de Experiencia" },
  { id: 2, number: "500+", label: "Proyectos Completados" },
  { id: 3, number: "100%", label: "Satisfacción del Cliente" },
  { id: 4, number: "24/7", label: "Soporte Técnico" }
];

export const faqs = [
  {
    id: 1,
    question: "¿Realizan envíos a toda la República Mexicana?",
    answer: "Sí, realizamos instalación y envíos a todo el territorio nacional. Coordinamos logística completa incluyendo transporte e instalación."
  },
  {
    id: 2,
    question: "¿Qué garantía tienen los equipos?",
    answer: "Todos nuestros equipos cuentan con garantía de fabricación y ofrecemos soporte técnico continuo. Los términos específicos varían según el equipo."
  },
  {
    id: 3,
    question: "¿Puedo solicitar un diseño personalizado?",
    answer: "Absolutamente. La personalización es nuestra especialidad. Trabajamos contigo desde el diseño hasta la instalación para crear la solución perfecta."
  },
  {
    id: 4,
    question: "¿Cuánto tiempo toma fabricar un equipo personalizado?",
    answer: "El tiempo de fabricación varía según la complejidad del proyecto, típicamente entre 4 y 12 semanas. Te proporcionamos un cronograma detallado al iniciar."
  },
  {
    id: 5,
    question: "¿Ofrecen capacitación para operar los equipos?",
    answer: "Sí, incluimos capacitación completa para tu personal durante la instalación, además de manuales detallados y soporte continuo."
  }
];
